// Browser-tab icon for a membership project.
//
// The creator sets it in the admin (Settings → General → General Code); it is
// stored on the project's funnels row (`funnels.favicon_url`) and reaches the
// learner app through the settings payload. Every page that knows its project
// should apply it, so the tab icon does not flip back to the bundled default
// when moving between the login page and the app.

import { asset } from "./assetUrl";

// Bundled fallback, used when a project has not set one. Resolved against the
// app's own origin — the bundle runs inside pages served from customer domains,
// where a bare /favicon.ico is the CUSTOMER's file, not ours.
export const DEFAULT_FAVICON = asset("/favicon.ico");

// Point the browser tab icon at the given URL, creating the <link> if the
// index.html one is missing. public/index.html ships
// `<link id="app-favicon" ...>` so this normally just swaps the href.
export function setFavicon(href) {
  if (!href) return;

  // Drop any OTHER icon link left pointing at the page origin's /favicon.ico.
  // When the bundle is embedded in a customer's page, that host template ships
  // its own `<link rel="icon" href="/favicon.ico">` for a file the customer
  // domain does not have — the browser fetches it, 404s, and logs it, even
  // though the icon this function sets is the one that ends up displayed. We
  // own the tab icon here, so remove the dead link rather than leave the noise.
  const dead = `${window.location.origin}/favicon.ico`;
  document.querySelectorAll('link[rel~="icon"]').forEach((l) => {
    if (l.id !== "app-favicon" && l.href === dead) l.remove();
  });

  let link = document.getElementById("app-favicon");
  if (!link) {
    link = document.createElement("link");
    link.id = "app-favicon";
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}
